import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { trackEvent, trackPageView } from '../utils/gt';

import { HomeHero } from '../components/landing/HomeHero';
import { HomeAlexa, HomeMore, HomeMoments, HomePlans } from '../components/landing/HomeSections';
import { HomeBuild } from '../components/landing/HomeBuild';
import { HomeCalories } from '../components/landing/HomeCalories';
import { HomeDiet } from '../components/landing/HomeDiet';
import { useAuthDialog } from '../components/auth/authDialogContext';
import '../styles/pages/landing.css';

export const Home = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { openAuth } = useAuthDialog();

  useEffect(() => {
    trackPageView('home', `${t('appUrl')}/`, '/');
  }, [t]);

  // The signup ads' link (/?cadastro=1): it opens the signup, and the new account lands on creating a workout,
  // the thing the ad shows. Someone already signed in goes straight there
  const [fromSignupLink] = useState(() => new URLSearchParams(window.location.search).get('cadastro') === '1');
  const openSignup = () => openAuth('signup', { afterSignupPath: fromSignupLink ? '/workout' : undefined });

  useEffect(() => {
    const authToken = localStorage.getItem('authToken');

    if (authToken) {
      navigate(fromSignupLink ? '/workout' : '/dashboard');
    } else if (fromSignupLink) {
      trackEvent('signup_link_open', 'Signup Link - Open Signup', 'signup_link', true);
      openSignup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="mt-root mt-root--page lp">
      <HomeHero
        onSignup={() => {
          trackEvent('hero_signup', 'Landing Hero - Click Start Free', 'landing_hero', true);
          openSignup();
        }}
        onSeePlans={() => {
          trackEvent('hero_plans', 'Landing Hero - Click See Plans', 'landing_hero', true);
          document.getElementById('planos')?.scrollIntoView({ behavior: 'smooth' });
        }}
      />
      <HomeMoments />
      <HomeAlexa />
      <HomeBuild />
      <HomeDiet />
      <HomeCalories />
      <HomeMore />
      <HomePlans
        onSignup={() => {
          trackEvent('sections_signup', 'Landing Sections - Click Signup', 'landing_sections', true);
          openSignup();
        }}
      />
    </div>
  );
};
